import {Component} from '@angular/core';

@Component({
  selector: 'app-tenant-help',
  standalone: true,
  imports: [],
  templateUrl: './tenant-help.component.html',
  styleUrl: './tenant-help.component.scss'
})
export class TenantHelpComponent {

}
